"use strict";

module.exports = /*@ngInject*/function (ProfileService, ServiceDeskService, superUsers) {
  var ctrl = this;
  ctrl.currentUser = ProfileService.getProfile();
  ctrl.superUsers = superUsers;
  ctrl.message = null;
  ctrl.add = function (user) {
    var match = ctrl.superUsers.find(function (superUser) {
      return superUser.userId === user.userId;
    });
    if (!match) {
      ServiceDeskService.addSuperUser(user).$promise.then(ctrl.getSuperUsers);
    } else {
      ctrl.message = "".concat(user.firstName, " ").concat(user.lastName, " is already a super user.");
    }
  };
  ctrl["delete"] = function (user) {
    ServiceDeskService.deleteSuperUser({
      userId: user.userId
    }, {}).$promise.then(ctrl.getSuperUsers);
  };
  ctrl.isCurrentUser = function (user) {
    if (user) {
      return ProfileService.isCurrentUser(user);
    }
  };
  ctrl.getSuperUsers = function () {
    ServiceDeskService.getSuperUsers().$promise.then(function (results) {
      ctrl.superUsers = results;
      ctrl.user = null;
    });
  };
};